import state from './merchantState'
import mutations from './merchantMutations'
import getters from './merchantGetters'
import actions from './merchantActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
